/**
 * Video with text section – play/pause for click-to-play mode.
 * Section-specific: each .video-with-text instance is initialised once (data-vwt-initialized).
 * Safe when the section is used multiple times on the same page.
 */
(function () {
  function initSection(sectionEl) {
    if (sectionEl.getAttribute('data-vwt-initialized') === 'true') return;
    var playIcon = sectionEl.querySelector('.vwt-play-icon');
    if (!playIcon) {
      sectionEl.setAttribute('data-vwt-initialized', 'true');
      return;
    }
    var desktopVideo = sectionEl.querySelector('.vwt-desktop-video');
    var mobileVideo = sectionEl.querySelector('.vwt-mobile-video');

    function isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    function handleVideoPlayback(video, icon) {
      if (!video) return;
      if (video.paused || video.ended) {
        video.play();
        icon.style.display = 'none';
      } else {
        video.pause();
        icon.style.display = 'block';
      }
    }

    playIcon.addEventListener('click', function () {
      if (isMobile() && mobileVideo) {
        handleVideoPlayback(mobileVideo, playIcon);
      } else {
        handleVideoPlayback(desktopVideo, playIcon);
      }
    });

    if (desktopVideo) {
      desktopVideo.addEventListener('click', function () {
        handleVideoPlayback(desktopVideo, playIcon);
      });
    }
    if (mobileVideo) {
      mobileVideo.addEventListener('click', function () {
        handleVideoPlayback(mobileVideo, playIcon);
      });
    }

    sectionEl.setAttribute('data-vwt-initialized', 'true');
  }

  function initAll() {
    document.querySelectorAll('.video-with-text:not([data-vwt-initialized])').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target.querySelector ? event.target.querySelector('.video-with-text') : null;
    if (sectionEl) {
      sectionEl.removeAttribute('data-vwt-initialized');
      initSection(sectionEl);
    } else if (event.target.classList && event.target.classList.contains('video-with-text')) {
      event.target.removeAttribute('data-vwt-initialized');
      initSection(event.target);
    }
  });
})();
